import axios from 'axios';

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
} as const;

export const isHttpStatus = (error: unknown, status: number): boolean =>
  axios.isAxiosError(error) && error.response?.status === status;

export const extractErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const serverMessage = error.response?.data?.message;
    if (typeof serverMessage === 'string' && serverMessage.trim()) return serverMessage;
  }
  return fallback;
};
